export const rootMenu = {
    '新增': 'CREATE',
    '编辑': 'UPDATE',
    '处理': 'SOLVE',
    '导入': 'IMPORT',
    '删除': 'DELETE',
    '查询': 'SEARCH',
    '搜索': 'SEARCH',
    '修改': 'UPDATE',
    '审核': 'APPROVE',
    '打印': 'PRINT',
    '二次核价': 'SUBMIT2',
    '提交二次核价': 'SUBMIT2_CONFIM',
    '取消二次核价': 'CANCEL_SUMBIT2',
    '生成扣款单': 'CREATE'
}
